import React, { FC } from 'react'
import ReactEchartsCore from 'echarts-for-react/lib/core';
import echarts from 'echarts/lib/echarts';
import 'echarts/lib/chart/pie'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/title'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/legendScroll'
import 'echarts/lib/chart/line'


export const GLDWZJ: FC<{ data: any }> = ({ data, ...props }) => {

	const option = {
		tooltip: {
			trigger: 'item',
			formatter: '{b} : {c} ({d}%)'
		  },
		  legend: {
            orient: 'vertical',
            left: 'right',
		  },
		  color:['#507AFF', '#F6563E', '#73DEB3',],
		  series: [
			{
			  name: '资产状态',
			  type: 'pie',
			  radius: ['40%', '70%'],
			  avoidLabelOverlap: false,
			  itemStyle: {
				borderRadius: 10,
				borderColor: '#fff',
				borderWidth: 2
			  },
			  label: {
				show: true,
				formatter(param) {
				  // correct the percentage
				  return param.name+param.value+ ' (' + param.percent  + '%)';
				}
			  },
			  startAngle: 120,
			//   emphasis: {
			// 	label: {
			// 	  show: true,
			// 	  fontSize: 40,
			// 	  fontWeight: 'bold'
			// 	}
			//   },
			  labelLine: {
				show: true
			  },
			  normal: {
				label: {
					show: true,
					formatter: '{b} : {c} ({d}%)'
				},
				labelLine: {
					show: true
				}
			},
			  data: data
			}
		  ]
		};

	
		
	return (
		<ReactEchartsCore
			className='firstImg'
			echarts={echarts}
			theme="pie"
			
			option={option as any}
		/>
	)
}